import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LinkTreePage from "./components/LinkTreePage";
import { initCookieConsent } from "./lib/cookieConsent";

function App() {
  useEffect(() => {
    initCookieConsent().catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LinkTreePage />} />
          <Route path="*" element={<LinkTreePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
